<template>
  <section class="header-wrapper">
    <el-header class="header">
      <div class="header-left">
        <router-link to="/">
          <el-image :src="url" fit="contain" class="logo"></el-image>
        </router-link>
        <el-menu :default-active="$route.path"
                 class="header-menu"
                 mode="horizontal"
                 @select="handleSelect"
                 router
                 active-text-color="#2aacb2">
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/course">选课中心</el-menu-item>
          <el-menu-item index="/news">资讯</el-menu-item>
          <el-menu-item index="/news/details?id=5">关于我们</el-menu-item>
          <el-menu-item index="/user/course">我的课程</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">
        <router-link to="/cart" class="header-cart" v-if="isLoggedIn">
          <el-icon class="el-icon-shopping-cart-2"></el-icon>
          <span class="header-cart-title">购物车</span>
        </router-link>
        <el-dropdown v-if="isLoggedIn" class="user-info" @command="handleCommand">
          <div class="el-dropdown-link">
            <el-avatar :size="35" :src="user ? user.avatar : avatar "></el-avatar>
            <span class="user-name">{{ user ? user.username : '源学用户' }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user">个人中心</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <ul v-else>
          <li>
            <router-link to="/login">
              <el-button type="primary" round size="medium">登录</el-button>
            </router-link>
          </li>
          <li>
            <router-link to="/login">
              <el-button round size="medium">注册</el-button>
            </router-link>
          </li>
        </ul>
      </div>
    </el-header>
  </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: "TheHeader",
  data() {
    return {
      url: require('../../static/images/logo.png'),
      avatar: require('../../static/images/default.jpg')
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    ...mapGetters([
      'user',
      'isLoggedIn'
    ])
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    async logout() {
      try {
        await this.$store.dispatch('logout')
        this.$message.success('退出成功')
        this.$router.push({path: '/'})
      } catch (error) {
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout()
      }
      if (command === 'user') {
        this.$router.push({path: '/user/course'})
      }
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  background-color: #ffffff;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .07)
}

.header-wrapper .header-menu {
  border-bottom: 0;
}

.header-wrapper .header {
  display: flex;
  justify-content: space-between;
}

.logo {
  width: 250px;
  height: 60px;
  margin-right: 50px;
}

.header-left {
  display: flex;
  justify-content: flex-start;
}

.header-right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-right ul {
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.header-right ul li {
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.user-info {
  height: 100%;
}

.user-info .el-dropdown-link {
  height: 100%;
  display: flex;
  align-items: center;
}

.user-name {
  margin-left: 10px
}

.header-cart{
  font-size: 14px;
  margin-right: 30px;
  cursor: pointer;
}

.header-cart-title{
  margin-left: 5px;
}
</style>
